__turbopack_context__.v({
  "badge": "n0yX4q_badge",
});
